/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileThreeD16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13 4.068l-3.6-1.85c-.5-.291-1.3-.291-1.8 0L4 4.069c-.6.292-1 .973-1 1.556v4.768c0 .681.4 1.265 1 1.557l3.6 1.849c.496.27 1.234.27 1.8 0L13 11.95c.6-.292 1-.973 1-1.557V5.624c0-.583-.4-1.264-1-1.556zM4.4 11.17c-.2-.098-.4-.487-.4-.681V5.722c0-.292.2-.584.4-.681L8 3.19c.2-.096.6-.096.9 0l3.6 1.85c.1.061.154.134.2.194L8.5 6.996v6.12c-.2 0-.282-.05-.4-.097l-3.7-1.848z"
        />
    </AccessibleSVG>
);

export default FileThreeD16;
